import { AuthorisedContacts, LegacyDocuments } from '../PrearrangementFragments';
import { buildTabDataFragment } from '../../../util/functions';
import gql from 'graphql-tag';

export default buildTabDataFragment(
    [
        gql`
            fragment PrearrangementCertificationFields on Prearrangement {
                ContractAmount
                TravelProtection
                FuneralFundCode
                FuneralFundName
            }
        `,
        AuthorisedContacts,
        LegacyDocuments
    ],
    'Prearrangement'
);
